var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayoutIconModbus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/modbus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 62"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 3,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 3,
    r: 2,
    stroke: "#313131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 63"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 21,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 21,
    r: 2,
    stroke: "#313131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 64"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 7,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 7,
    r: 2,
    stroke: "#313131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 65"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 16,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 16,
    r: 2,
    stroke: "#313131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 66"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 17,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 17,
    r: 2,
    stroke: "#313131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 67"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8,
    r: 2,
    stroke: "#313131"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20ZM12.5 19C16.366 19 19.5 15.866 19.5 12C19.5 8.13401 16.366 5 12.5 5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutIconModbus);
export default __webpack_public_path__ + "static/media/layout-icon-modbus.dae04f75bb24bf2ae2cf88865ac27102.svg";
export { ForwardRef as ReactComponent };